var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 72.6942,
    x2: 32,
    y2: 29.3282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    style: {
      stopColor: "#97EFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#3DB6D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D6FD3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 32,
    cy: 32,
    r: 28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 43.5,
    x2: 32,
    y2: -16.3614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    style: {
      stopColor: "#97EFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#3DB6D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D6FD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M4,32c0,4.827,1.222,9.369,3.373,13.333h49.255C58.778,41.369,60,36.827,60,32 C60,16.536,47.464,4,32,4S4,16.536,4,32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7055,
    y1: 29.113,
    x2: 22.7055,
    y2: -23.8074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M31.458,16.823c-6.638-2.22-12.21-5.79-13.816-8.146c-0.121-0.178-0.251-0.334-0.384-0.48 c-1.161,0.72-2.265,1.524-3.304,2.401C23.783,14.657,31.458,16.823,31.458,16.823z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4859,
    y1: 29.9468,
    x2: 15.4859,
    y2: -22.0629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M22.727,19.908c-3.546-0.494-6.682-1.767-7.711-2.802c-1.029-1.034-3.43-1.135-4.041-1.65 c-0.766-0.646-0.754-0.52-1.016-0.715c-0.613,0.782-1.186,1.595-1.714,2.44C15.838,19.276,22.727,19.908,22.727,19.908z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.1045,
    y1: 34.8514,
    x2: 49.1045,
    y2: -42.4357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M57.721,20.927c-0.551-0.011-1.14,0.085-1.757,0.356c-2.318,1.021-4.109-0.478-7.541,0.245 c-3.432,0.722-9.32-0.377-9.32-0.377c8.468,2.617,15.124,3.574,20.004,3.808C58.746,23.57,58.28,22.224,57.721,20.927z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4881,
    y1: 35.0902,
    x2: 47.4881,
    y2: -43.5701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M54.989,16.023c-0.421-0.078-0.839-0.21-1.095-0.431c-0.683-0.588-1.717,0.065-2.026-0.594 c-0.309-0.66-1.346-1.575-2.705-0.887c-1.359,0.688-2.276-0.334-4.243,0.149c-1.967,0.482-5.205-0.277-5.205-0.277 c8.119,3.172,13.373,2.823,15.547,2.431C55.173,16.281,55.08,16.153,54.989,16.023z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.381,
    y1: 35.0916,
    x2: 409.381,
    y2: -43.5742,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M30.37,8.641c0,0,3.78,1.26,5.585,0.928c0,0-1.085-0.357-1.504-0.734 s-1.382-0.624-1.792-0.373c-0.41,0.252-0.566-0.363-1.026-0.133C31.173,8.56,30.37,8.641,30.37,8.641z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.2635,
    y1: 35.0919,
    x2: 407.2635,
    y2: -43.5739,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M28.252,19.852c0,0,3.78,1.26,5.585,0.928c0,0-1.085-0.357-1.504-0.734 c-0.419-0.376-1.382-0.624-1.792-0.373c-0.41,0.252-0.566-0.363-1.026-0.133C29.055,19.771,28.252,19.852,28.252,19.852z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.7072,
    y1: 34.0957,
    x2: 46.7072,
    y2: -41.6395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M47.647,8.777c-0.076-0.001-0.149-0.023-0.213-0.113c-0.043-0.06-0.118-0.106-0.197-0.15 c-0.018-0.012-0.036-0.023-0.054-0.034c-0.307-0.14-0.774-0.174-1.062-0.074c-0.389,0.134-1.221,0.066-1.221,0.066 c0.864,0.567,2.78,0.831,3.617,0.923C48.229,9.184,47.941,8.976,47.647,8.777z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.5945,
    y1: 44.1475,
    x2: 19.5945,
    y2: 12.123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    style: {
      stopColor: "#97EFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#3DB6D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D6FD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M34.483,38.629H17.99v-7.013h-2.151v-4.645c0-1.669-1.353-3.022-3.022-3.022 s-3.022,1.353-3.022,3.022v7.196H4.092c0.308,4.018,1.456,7.802,3.281,11.167h27.725L34.483,38.629z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.5979,
    y1: 54.5526,
    x2: 32.5979,
    y2: 9.4801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    style: {
      stopColor: "#97EFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#3DB6D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D6FD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M60,32c0-3.065-0.5-6.012-1.41-8.773h-1.714c-2.971,0-5.379,2.408-5.379,5.379v3.205 h-5.845c-0.591,0-1.07,0.479-1.07,1.07v5.194h-7.375v-2.001c0-0.536-0.434-0.97-0.97-0.97h-2.104V15.866 c0-0.514-0.417-0.93-0.93-0.93H21.082c-0.514,0-0.93,0.417-0.93,0.93v26.145h-9.68v-1.906H5.196 c0.552,1.828,1.282,3.579,2.177,5.229h49.255C58.778,41.369,60,36.827,60,32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7749,
    x2: 399.4093,
    y2: -0.2781,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M23.691,18.649H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,18.608,23.741,18.649,23.691,18.649z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7749,
    x2: 401.461,
    y2: -0.2781,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M25.743,18.649h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,18.608,25.793,18.649,25.743,18.649z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7749,
    x2: 403.5127,
    y2: -0.2781,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M27.795,18.649h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,18.608,27.845,18.649,27.795,18.649z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7749,
    x2: 405.5643,
    y2: -0.2781,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M29.846,18.649h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,18.608,29.896,18.649,29.846,18.649z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7749,
    x2: 407.616,
    y2: -0.2781,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M31.898,18.649h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,18.608,31.948,18.649,31.898,18.649z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7773,
    x2: 399.4093,
    y2: -0.2799,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M23.691,20.81H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,20.769,23.741,20.81,23.691,20.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7773,
    x2: 401.461,
    y2: -0.2799,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    d: "M25.743,20.81h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,20.769,25.793,20.81,25.743,20.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7773,
    x2: 403.5127,
    y2: -0.2799,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    d: "M27.795,20.81h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,20.769,27.845,20.81,27.795,20.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7773,
    x2: 405.5643,
    y2: -0.2799,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M29.846,20.81h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,20.769,29.896,20.81,29.846,20.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7773,
    x2: 407.616,
    y2: -0.2799,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    d: "M31.898,20.81h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,20.769,31.948,20.81,31.898,20.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.775,
    x2: 399.4093,
    y2: -0.278,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    d: "M23.691,22.971H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,22.93,23.741,22.971,23.691,22.971z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.775,
    x2: 401.461,
    y2: -0.278,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_23_)"
    },
    d: "M25.743,22.971h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,22.93,25.793,22.971,25.743,22.971z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.775,
    x2: 403.5127,
    y2: -0.278,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_24_)"
    },
    d: "M27.795,22.971h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,22.93,27.845,22.971,27.795,22.971z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.775,
    x2: 405.5643,
    y2: -0.278,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_25_)"
    },
    d: "M29.846,22.971h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,22.93,29.896,22.971,29.846,22.971z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.775,
    x2: 407.616,
    y2: -0.278,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_26_)"
    },
    d: "M31.898,22.971h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,22.93,31.948,22.971,31.898,22.971z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7771,
    x2: 399.4093,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_27_)"
    },
    d: "M23.691,25.132H22.69c-0.05,0-0.091-0.041-0.091-0.091V24.04 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,25.091,23.741,25.132,23.691,25.132z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7771,
    x2: 401.461,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_28_)"
    },
    d: "M25.743,25.132h-1.002c-0.05,0-0.091-0.041-0.091-0.091V24.04 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,25.091,25.793,25.132,25.743,25.132z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7771,
    x2: 403.5127,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_29_)"
    },
    d: "M27.795,25.132h-1.001c-0.05,0-0.091-0.041-0.091-0.091V24.04 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,25.091,27.845,25.132,27.795,25.132z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7771,
    x2: 405.5643,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_30_)"
    },
    d: "M29.846,25.132h-1.002c-0.05,0-0.091-0.041-0.091-0.091V24.04 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,25.091,29.896,25.132,29.846,25.132z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7771,
    x2: 407.616,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_31_)"
    },
    d: "M31.898,25.132h-1.002c-0.05,0-0.091-0.041-0.091-0.091V24.04 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,25.091,31.948,25.132,31.898,25.132z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7771,
    x2: 399.4093,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_32_)"
    },
    d: "M23.691,27.294H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,27.252,23.741,27.294,23.691,27.294z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7771,
    x2: 401.461,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_33_)"
    },
    d: "M25.743,27.294h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,27.252,25.793,27.294,25.743,27.294z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7771,
    x2: 403.5127,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_34_)"
    },
    d: "M27.795,27.294h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,27.252,27.845,27.294,27.795,27.294z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7771,
    x2: 405.5643,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_35_)"
    },
    d: "M29.846,27.294h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,27.252,29.896,27.294,29.846,27.294z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7771,
    x2: 407.616,
    y2: -0.28,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_36_)"
    },
    d: "M31.898,27.294h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,27.252,31.948,27.294,31.898,27.294z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.777,
    x2: 399.4093,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_37_)"
    },
    d: "M23.691,29.455H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,29.414,23.741,29.455,23.691,29.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.777,
    x2: 401.461,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_38_)"
    },
    d: "M25.743,29.455h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,29.414,25.793,29.455,25.743,29.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.777,
    x2: 403.5127,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_39_)"
    },
    d: "M27.795,29.455h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,29.414,27.845,29.455,27.795,29.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.777,
    x2: 405.5643,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_40_)"
    },
    d: "M29.846,29.455h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,29.414,29.896,29.455,29.846,29.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.777,
    x2: 407.616,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_41_)"
    },
    d: "M31.898,29.455h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,29.414,31.948,29.455,31.898,29.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.777,
    x2: 399.4093,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_42_)"
    },
    d: "M23.691,31.616H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,31.575,23.741,31.616,23.691,31.616z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.777,
    x2: 401.461,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_43_)"
    },
    d: "M25.743,31.616h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,31.575,25.793,31.616,25.743,31.616z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.777,
    x2: 403.5127,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_44_)"
    },
    d: "M27.795,31.616h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,31.575,27.845,31.616,27.795,31.616z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.777,
    x2: 405.5643,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_45_)"
    },
    d: "M29.846,31.616h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,31.575,29.896,31.616,29.846,31.616z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.777,
    x2: 407.616,
    y2: -0.2801,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_46_)"
    },
    d: "M31.898,31.616h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,31.575,31.948,31.616,31.898,31.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7756,
    x2: 399.4093,
    y2: -0.2774,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_47_)"
    },
    d: "M23.691,33.777H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,33.736,23.741,33.777,23.691,33.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7756,
    x2: 401.461,
    y2: -0.2774,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_48_)"
    },
    d: "M25.743,33.777h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,33.736,25.793,33.777,25.743,33.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7756,
    x2: 403.5127,
    y2: -0.2774,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_49_)"
    },
    d: "M27.795,33.777h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,33.736,27.845,33.777,27.795,33.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7756,
    x2: 405.5643,
    y2: -0.2774,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_50_)"
    },
    d: "M29.846,33.777h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,33.736,29.896,33.777,29.846,33.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7756,
    x2: 407.616,
    y2: -0.2774,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_51_)"
    },
    d: "M31.898,33.777h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,33.736,31.948,33.777,31.898,33.777z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7769,
    x2: 399.4093,
    y2: -0.2802,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_52_)"
    },
    d: "M23.691,35.938H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,35.897,23.741,35.938,23.691,35.938z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7769,
    x2: 401.461,
    y2: -0.2802,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_53_)"
    },
    d: "M25.743,35.938h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,35.897,25.793,35.938,25.743,35.938z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7769,
    x2: 403.5127,
    y2: -0.2802,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_54_)"
    },
    d: "M27.795,35.938h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,35.897,27.845,35.938,27.795,35.938z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7769,
    x2: 405.5643,
    y2: -0.2802,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_55_)"
    },
    d: "M29.846,35.938h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,35.897,29.896,35.938,29.846,35.938z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7769,
    x2: 407.616,
    y2: -0.2802,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_56_)"
    },
    d: "M31.898,35.938h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,35.897,31.948,35.938,31.898,35.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7758,
    x2: 399.4093,
    y2: -0.2772,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_57_)"
    },
    d: "M23.691,38.099H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,38.058,23.741,38.099,23.691,38.099z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7758,
    x2: 401.461,
    y2: -0.2772,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_58_)"
    },
    d: "M25.743,38.099h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,38.058,25.793,38.099,25.743,38.099z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7758,
    x2: 403.5127,
    y2: -0.2772,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_59_)"
    },
    d: "M27.795,38.099h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,38.058,27.845,38.099,27.795,38.099z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7758,
    x2: 405.5643,
    y2: -0.2772,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_60_)"
    },
    d: "M29.846,38.099h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,38.058,29.896,38.099,29.846,38.099z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7758,
    x2: 407.616,
    y2: -0.2772,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_61_)"
    },
    d: "M31.898,38.099h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,38.058,31.948,38.099,31.898,38.099z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.4093,
    y1: 48.7767,
    x2: 399.4093,
    y2: -0.2804,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_62_)"
    },
    d: "M23.691,40.26H22.69c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C23.782,40.219,23.741,40.26,23.691,40.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.461,
    y1: 48.7767,
    x2: 401.461,
    y2: -0.2804,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_63_)"
    },
    d: "M25.743,40.26h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C25.834,40.219,25.793,40.26,25.743,40.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.5127,
    y1: 48.7767,
    x2: 403.5127,
    y2: -0.2804,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_64_)"
    },
    d: "M27.795,40.26h-1.001c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.001c0.05,0,0.091,0.041,0.091,0.091v1.001C27.886,40.219,27.845,40.26,27.795,40.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.5643,
    y1: 48.7767,
    x2: 405.5643,
    y2: -0.2804,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_65_)"
    },
    d: "M29.846,40.26h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C29.937,40.219,29.896,40.26,29.846,40.26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.616,
    y1: 48.7767,
    x2: 407.616,
    y2: -0.2804,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_66_)"
    },
    d: "M31.898,40.26h-1.002c-0.05,0-0.091-0.041-0.091-0.091v-1.001 c0-0.05,0.041-0.091,0.091-0.091h1.002c0.05,0,0.091,0.041,0.091,0.091v1.001C31.989,40.219,31.948,40.26,31.898,40.26z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.5681,
    y1: 44.8723,
    x2: 420.5681,
    y2: 14.9079,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    style: {
      stopColor: "#97EFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5207,
    style: {
      stopColor: "#3DB6D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D6FD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_67_)"
    },
    d: "M45.652,31.812c-0.591,0-1.07,0.479-1.07,1.07v5.194h-7.375l-0.005,0.269 c-0.049,2.622,2.063,4.775,4.686,4.775h3.181v-1.962h6.428v-9.344H45.652z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.5124,
    y1: 25.687,
    x2: 387.5124,
    y2: 25.1268,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49,
      fill: "url(#SVGID_68_)"
    },
    d: "M11.047,25.389c-0.067,0.019,0.052,0.116,0.192,0.211 c0.001-0.001,0.002-0.003,0.004-0.004l0.111-0.026c0.082-0.019,0.152-0.063,0.205-0.121C11.556,25.447,11.186,25.35,11.047,25.389 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.4349,
    y1: 56.2465,
    x2: 387.4349,
    y2: 35.5285,
    gradientTransform: "matrix(1 0 0 1 -376.2188 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7FF1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    style: {
      stopColor: "#2FBCA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F7DA4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_69_)"
    },
    d: "M7.271,45.597c0-1.006,0.675-1.854,1.597-2.116c0.302-0.086,0.535-0.329,0.624-0.63 c0.284-0.958,1.202-1.642,2.267-1.568c1.064,0.074,1.934,0.925,2.032,1.987c0.016,0.17,0.012,0.336-0.009,0.497 c-0.044,0.332,0.109,0.661,0.389,0.846c0.597,0.394,0.99,1.069,0.99,1.838c0,0.617-0.254,1.174-0.663,1.573 c-0.136,0.133-0.256,0.284-0.329,0.46c-0.237,0.563-0.792,0.958-1.441,0.958c-0.069,0-0.136-0.004-0.202-0.013 c-0.356-0.046-0.717,0.013-1.023,0.199c-0.332,0.201-0.72,0.316-1.136,0.316c-1.215,0-2.2-0.985-2.2-2.2c0-0.007,0-0.013,0-0.02 c0.002-0.211-0.082-0.41-0.233-0.557C7.524,46.769,7.271,46.212,7.271,45.597z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: -13967.8408,
    y1: 54.555,
    x2: -13967.8408,
    y2: 37.9944,
    gradientTransform: "matrix(-1 0 0 1 -13956.874 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#CDDFEC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_70_)"
    },
    d: "M9.533,46.409c0.022,0.07,0.04,0.142,0.065,0.209c0.025,0.068,0.061,0.131,0.106,0.187 c0.045,0.056,0.098,0.105,0.157,0.145c0.059,0.04,0.127,0.068,0.192,0.101l0.332,0.162c-0.01-0.021-0.02-0.043-0.028-0.065 c-0.023-0.071-0.039-0.142-0.058-0.213l-0.112-0.425l0.126,0.421c0.022,0.07,0.04,0.142,0.065,0.209 c0.012,0.031,0.026,0.06,0.041,0.088l0.03,0.015l0.001,0c0.014,0.007,0.019,0.025,0.012,0.039 c-0.001,0.002-0.003,0.004-0.005,0.006c0.009,0.013,0.017,0.027,0.027,0.04c0.045,0.056,0.098,0.105,0.157,0.145 c0.059,0.04,0.127,0.068,0.192,0.101l0.354,0.172l0.029-1.987l0.038,2.596l0.196-0.101c0.084-0.041,0.158-0.088,0.221-0.153 c0.063-0.065,0.112-0.142,0.145-0.226c0.018-0.042,0.025-0.084,0.042-0.132c0.018-0.046,0.048-0.086,0.086-0.117 c0.037-0.031,0.085-0.05,0.131-0.06c0.044-0.012,0.092-0.02,0.133-0.035c0.085-0.03,0.154-0.1,0.184-0.186 c0.047-0.178,0.089-0.36,0.134-0.539c-0.04,0.181-0.077,0.362-0.12,0.544c-0.029,0.09-0.101,0.167-0.19,0.201 c-0.046,0.017-0.09,0.026-0.135,0.039c-0.045,0.01-0.085,0.028-0.119,0.057c-0.033,0.028-0.059,0.065-0.074,0.106 c-0.013,0.04-0.021,0.09-0.038,0.134c-0.032,0.089-0.083,0.173-0.148,0.243c-0.064,0.071-0.147,0.126-0.229,0.168l-0.219,0.12 l0.076,5.201c0,0.001,0,0.002,0,0.003c-0.001,0.063-0.053,0.114-0.116,0.113s-0.113-0.053-0.113-0.116l0.085-5.811l-0.372-0.196 c-0.064-0.035-0.132-0.065-0.193-0.11c-0.061-0.044-0.115-0.097-0.16-0.157c-0.011-0.015-0.02-0.032-0.03-0.049 c-0.003,0-0.005-0.001-0.008-0.002l-0.389-0.205c-0.064-0.035-0.132-0.065-0.193-0.11c-0.061-0.044-0.115-0.097-0.16-0.157 c-0.045-0.06-0.08-0.127-0.103-0.197c-0.023-0.071-0.039-0.142-0.058-0.213l-0.112-0.425L9.533,46.409z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.6445,
    y1: 0.6557,
    x2: 24.6078,
    y2: 31.5436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_71_)"
    },
    d: "M19.552,20.323c0,0,7.475-3.066,6.452-11.135c-0.633-4.99,8.317-7.359,10.351-2.614 c1.462,3.411,1.272,5.52,1.05,6.437c-0.076,0.316-0.364,0.535-0.689,0.535l0,0c-0.34,0-0.621,0.264-0.641,0.603 c-0.049,0.827-0.375,2.265-1.995,2.737c-2.324,0.678-4.038,2.651-2.227,2.905c1.811,0.254,0.29,6.487-0.194,6.778 c-0.484,0.291-5.056,5.995-5.056,5.995"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.697,
    y1: 0.4863,
    x2: 40.1204,
    y2: 23.5313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_72_)"
    },
    d: "M36.11,13.98c0.081-0.238,0.296-0.409,0.554-0.429c-0.148-0.036-0.253-0.207-0.116-0.731 c0.291-1.113,0.323-3.453-0.42-3.938C35.474,8.454,36.254,11.897,36.11,13.98z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.6435,
    y1: 3.7249,
    x2: 30.0669,
    y2: 26.7697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_73_)"
    },
    d: "M29.553,18.282c0.577,0.155,1.204,0.227,1.843,0.242c0.474-0.603,1.461-1.263,2.606-1.613 c-0.927,0.253-2.215,0.14-3.989-0.557c-3.946-1.549-3.914-5.52-3.914-5.52l-0.001,0.002c-0.072,4.995-3.527,7.755-5.388,8.88 l-0.017,0.028h5.602c0,0-1.607-0.508-1.462-1.089C24.977,18.072,26.454,17.45,29.553,18.282z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.4659,
    y1: 1.4563,
    x2: 36.9205,
    y2: 24.5982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_74_)"
    },
    d: "M34.339,16.797c0.042-0.016,0.081-0.035,0.121-0.052 C34.42,16.763,34.38,16.78,34.339,16.797z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5494,
    y1: 1.1783,
    x2: 37.9727,
    y2: 24.2228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_75_)"
    },
    d: "M34.479,16.735c0.982-0.444,1.372-1.292,1.518-2.004 C35.767,15.592,35.307,16.34,34.479,16.735z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.4996,
    y1: 57.1968,
    x2: 64.7512,
    y2: 30.9452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    style: {
      stopColor: "#000741"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5019_",
    style: {
      fill: "url(#XMLID_2_)"
    },
    d: "M60,42.305c0-3.65-2.959-6.608-6.608-6.608 c-3.65,0-6.608,2.959-6.608,6.608s2.959,6.608,6.608,6.608C57.041,48.913,60,45.954,60,42.305z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.5897,
    y1: 50.79,
    x2: 15.0755,
    y2: 14.6411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5018_",
    style: {
      fill: "url(#XMLID_3_)"
    },
    d: "M34.624,21.26c0,0,0.99,11.294,17.627,12.859 c0.183,0.017,0.368,0.029,0.552,0.034c0.856,0.024,4.36,0.304,5.649,3.218c0,0,0.871,0.939-1.934,0.906 c-1.237-0.014-2.354-0.66-3.072-1.668c-0.578-0.811-1.999-1.068-3.154-0.874c-2.223,0.373-15.874,2.543-19.795-6.795L34.624,21.26 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.3269,
    y1: 61.7913,
    x2: 31.3269,
    y2: 44.0712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_76_)"
    },
    d: "M34.055,45.579l-3.333-0.446l-9.376,6.53c4.247,1.177,7.688,4.344,10.46,8.332 C31.871,59.995,31.935,60,32,60c3.264,0,6.395-0.564,9.307-1.591C38.192,49.658,34.055,45.579,34.055,45.579z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.3697,
    y1: 73.1599,
    x2: 23.6527,
    y2: 30.0955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    style: {
      stopColor: "#000741"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_77_)"
    },
    d: "M34.957,45.09c-9.272,5.201-18.388,5.827-23.807,5.593 c2.94,3.278,6.641,5.856,10.826,7.461c2.488-0.957,5.458-0.452,7.474,1.676c0.024,0.026,0.056,0.041,0.081,0.065 C30.345,59.957,31.167,60,32,60c0.503,0,1.002-0.015,1.498-0.041c2.671-1.229,5.472-3.507,6.876-4.737 c0.575-0.503,0.784-1.314,0.504-2.024C38.975,48.366,34.957,45.09,34.957,45.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.7188,
    y1: 62.3621,
    x2: 22.0739,
    y2: 42.5683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    style: {
      stopColor: "#000741"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_78_)"
    },
    d: "M11.15,50.683c1.738,1.938,3.743,3.629,5.955,5.022c0.307-0.02,0.623-0.034,0.949-0.04 C28.415,55.472,34.957,45.09,34.957,45.09C25.684,50.291,16.569,50.917,11.15,50.683z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.2705,
    y1: 76.2926,
    x2: 20.2705,
    y2: -5.4744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0143,
    style: {
      stopColor: "#FFC00F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    style: {
      stopColor: "#FF9C0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5D0F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_79_)"
    },
    d: "M34.239,23.602c0.164-0.302,0.294-0.622,0.374-0.956c0.607-2.554-1.81-3.144-3.304-3.269 c-0.163-0.014-0.23,0.2-0.09,0.285c0.006,0.003,0.011,0.007,0.017,0.01c0.649,0.399,0.342,1.41-0.42,1.414l-0.043,0 c-1.091,0.006-2.177-0.241-3.128-0.776c-1.168-0.657-2.877-0.956-2.877-0.956c-2.56-0.34-5.151-0.292-7.207,1.771 C5.338,33.39,5.456,49.107,5.62,52.325c0.018,0.342,0.276,0.624,0.616,0.668c20.506,2.65,28.721-7.903,28.721-7.903 C25.74,34.896,32.433,26.937,34.239,23.602z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: -20.6324,
    y1: 43.6354,
    x2: 53.7293,
    y2: 29.9722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0143,
    style: {
      stopColor: "#FFC00F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    style: {
      stopColor: "#FF9C0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5D0F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_80_)"
    },
    d: "M19.313,47.532c-7.359,2.614-11.716-6.584-3.099-8.133 c4.585-0.824,8.12-4.045,10.425-6.879c0.698-0.858,0.278-2.102-0.769-2.457c-0.913-0.309-1.12-1.513-0.049-2.574 c0.057-0.057,0.112-0.113,0.165-0.17c2.011-2.162,1.413-5.65-1.137-7.139c-2.23-1.302-5.233-1.117-7.289,0.946 C5.337,33.391,5.456,49.111,5.621,52.326c0.017,0.341,0.276,0.623,0.615,0.667c5.019,0.649,9.299,0.505,12.905-0.079 c2.248-0.54,4.124-0.994,5.223-1.266c0.339-0.112,0.67-0.228,0.991-0.347C28.849,49.64,26.112,45.116,19.313,47.532z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.158,
    y1: 51.1977,
    x2: 5.2839,
    y2: 10.0434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFB699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#F47E6D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_81_)"
    },
    d: "M18.513,22.202c0,0-16.279,11.534-4.519,31.235c0.023,0.02,0.045,0.04,0.069,0.059 c0.257,0.196,0.528,0.414,0.811,0.647c2.46,1.906,5.246,3.409,8.26,4.415c-3.154-4.89-8.679-15.516-2.851-24.101 C29.222,21.289,20.911,19.82,18.513,22.202z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.2036,
    y1: 10.3535,
    x2: 23.8765,
    y2: -6.0103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF3E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    style: {
      stopColor: "#000741"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_82_)"
    },
    d: "M25.688,10.314c0.052,0.27,0.357,0.398,0.59,0.253c1.213-0.758,3.078-1.448,5.229-1.86 c2.15-0.412,4.139-0.46,5.546-0.203c0.27,0.049,0.507-0.183,0.455-0.453l-0.013-0.067c-0.029-0.152-0.145-0.273-0.296-0.307 c-1.417-0.326-3.546-0.304-5.862,0.14s-4.303,1.21-5.499,2.036c-0.127,0.088-0.191,0.243-0.161,0.395L25.688,10.314z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.230769fdab5bb39c9aa1a1179598a2b8.svg";
export { ForwardRef as ReactComponent };